import axios, { AxiosPromise } from 'axios';
import _ from 'lodash';

export function getHostUG (): string {
    // La URL configurada en localstorage['configServer'] tiene la prioridad mas alta
    return localStorage.getItem('config.serverUG')
        // Si no existe URL configurada de forma local se tomará del entorno
        || process.env.VUE_APP_API_URL_UNIGEST_SERVE
        // Por último, si no se ha podido determinar la URL se presupone que la app
        // se encuentra en el mismo domino que el servicio
        || `${window.location.protocol}//${window.location.hostname}/'UniGest.Servicio.A.svc/api'`
}

// Token permanente del agente unigest server
// Esto quiere decir que esta clase hace llamadas con la autorización del agente, tenga en cuenta que no se puede llamar a cualquier recurso con esta 
// autorización porque el agente tiene asignado o permitido unos ciertos recursos que están en una lista de Prefixes admitidos para el agente,
// ver lista en unigest server EndPoindPrefixesForAgent, o sea, solo puede llamar a los que está p.e.:
// api/admin/<mi_recurso_api> todo recurso que esté en el path api/admi/ se le admite.
const token: string = 'Q0hpOExSdk5SYXZqV0JmTmhjYnlVZkRlL29tQW9YMnBHTTErTURsUTJGaz06wqEqQWdlbnRlKiE6NjQxODY4MTkyMDAwMDAwMDAwOg=='; //'//NLu6xZ3rFBi58XUuv4nWMH5RKFN9C+Dpl4hcoT9gg+aoDGKqG+pTXQ0jwK2OZmV7MyQhycuJwEYtjjaW+mR/CnpgW56sJVJxGtperEMvAkxIUKCvKqaCRGT5CiEVxFHroFFaGDh2GA/Pv+KDwR3dqJf6+eW0lLMEK/U66uFxmVk=';

const configUG = {
    baseURL: getHostUG(),
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
    },
};

const _axios = axios.create(configUG);

class ApiUnigestService {
  private baseURL: string;
  // Token agente
  //public token: string = 'Q0hpOExSdk5SYXZqV0JmTmhjYnlVZkRlL29tQW9YMnBHTTErTURsUTJGaz06wqEqQWdlbnRlKiE6NjQxODY4MTkyMDAwMDAwMDAwOg=='; //'//NLu6xZ3rFBi58XUuv4nWMH5RKFN9C+Dpl4hcoT9gg+aoDGKqG+pTXQ0jwK2OZmV7MyQhycuJwEYtjjaW+mR/CnpgW56sJVJxGtperEMvAkxIUKCvKqaCRGT5CiEVxFHroFFaGDh2GA/Pv+KDwR3dqJf6+eW0lLMEK/U66uFxmVk=';
  constructor() {
    this.baseURL = configUG.baseURL; //'http://192.168.255.56:8082/UniGestServicio.svc/api/'; // Reemplaza con la URL de tu API
    this.initializeInterceptors();
  }

  public setBaseUrl(url:string) {
    this.baseURL = url;
  } 

  /* setToken(token:string) {
    this.token = token;
  }  */

  initializeInterceptors() {
/*     // Interceptor para agregar el encabezado de autorización a todas las solicitudes
    _axios.interceptors.request.use((config) => {
      //if (this.token) {
      //  config.headers = `Bearer ${this.token}`;
      //  config.headers.Authorization = `Bearer ${this.token}`;
      //} 
      config.headers =  configUG.headers;
      return config;
    }); */

    // Interceptor para manejar errores comunes de la API
   _axios.interceptors.response.use(
    (response) => {
         return response.data;
    },
    (error) => {
      //throw new Error(_.get(error, 'response.data.message', error.message))
      error.message = _.get(error, 'response.data.message', error.message)
      // Do something with response error
      return Promise.reject(error);
    }); 
   
    // Interceptor para manejar errores comunes de la API
   /*  _axios.interceptors.response.use(
      (response) => response,
       (error) => {
        if (error.response && error.response.status === 401) {
          // Manejar la lógica para el manejo de errores de autenticación (por ejemplo, redirigir al inicio de sesión)
          // Puedes personalizar esto según tus necesidades
        }
        return Promise.reject(error);
      }
    ); */
  }

  get(endpoint:string): AxiosPromise<any> {
    return _axios.get(`${this.baseURL}${endpoint}`);
  }

  post(endpoint:string, data:any): AxiosPromise<any> {
      return _axios.post(`${this.baseURL}${endpoint}`, data);
  }

  put(endpoint:string, data:any): AxiosPromise<any> {
      return _axios.put(`${this.baseURL}${endpoint}`, data);
  }
}

export default new ApiUnigestService();
